import { defaultEditorValue } from '@tunasong/models'
import type { CoreElement, TunaDecendant } from '@tunasong/schemas'
import { createCollaborativeDoc } from '@tunasong/sync-lib'

/** Create a yDoc string from Slate nodes. */
export const getYDocString = (id: string, nodes: TunaDecendant[]) => {
  const { yDoc } = createCollaborativeDoc({ id, nodes })
  return yDoc
}

export const getYDocBinary = (id: string, nodes: TunaDecendant[]) => {
  const { yDocAsUpdates } = createCollaborativeDoc({ id, nodes })
  return yDocAsUpdates
}

export const getDefaultYDocString = (id?: string) => {
  const { yDoc } = createCollaborativeDoc({ id, nodes: defaultEditorValue })
  return yDoc
}

/** Convert plain text to Slate line elements. Each paragraph becomes a line node. */
export const textToSlateNodes = (text: string): CoreElement[] =>
  text
    .split('\n\n')
    .filter(Boolean)
    .map(paragraph => ({ type: 'line', children: [{ text: paragraph.trim() }] }))

/** Create a yDoc string from plain text. Paragraphs (double newlines) become separate lines. */
export const textToYDoc = (id: string, text: string) => getYDocString(id, textToSlateNodes(text))
